module.exports = __webpack_public_path__ + "img/intellij-idea.1a174a8f.svg";